import React from 'react';
import { CheckIcon } from 'lucide-react';
export function ForYou() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const points = ['Sentís que tu carrera no está generando ingresos estables', 'Querés explorar nuevas oportunidades laborales', 'Te interesa el mundo corporativo', 'No sabés cómo entrar a RRHH', 'Querés usar tu título en otro contexto', 'Buscás una alternativa concreta, no teoría'];
  return <section className="py-12 md:py-20 bg-slate-50" data-id="element-37">
      <div className="max-w-4xl mx-auto px-4" data-id="element-38">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-39">
          ESTE PROGRAMA ES PARA VOS SI...
        </h2>
        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12" data-id="element-40">
          <div className="space-y-4" data-id="element-41">
            {points.map((point, index) => <div key={index} onClick={scrollToCompra} className="flex items-start gap-4 p-4 rounded-lg hover:bg-slate-50 transition-all cursor-pointer" data-id="element-42">
                <CheckIcon className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-43" />
                <p className="text-gray-800 text-lg" data-id="element-44">{point}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}